import { authedApiFetch } from 'utils/Api';

const healthScoresService = {
	// GET /health_scores returns an array ordered most-recent first, so callers
	// can take [0] for the latest score. Both params are optional server-side.
	getHealthScores: async ({
		salesforceObjectId,
		salesforceObjectType = 'Account',
	} = {}) => {
		const params = new URLSearchParams();
		if (salesforceObjectId)
			params.set('salesforce_object_id', salesforceObjectId);
		if (salesforceObjectType)
			params.set('salesforce_object_type', salesforceObjectType);

		const queryString = params.toString();
		const endpoint = `/health_scores${queryString ? `?${queryString}` : ''}`;

		return await authedApiFetch({
			endpoint,
			method: 'GET',
		});
	},

	// POST /health_scores/regenerate_summary regenerates the AI summaries for the
	// record's latest health score and returns that score in the same shape as
	// getHealthScores returns its entries. Synchronous, so it takes a few seconds.
	regenerateSummary: async ({
		salesforceObjectId,
		salesforceObjectType = 'Account',
	}) => {
		return await authedApiFetch({
			endpoint: '/health_scores/regenerate_summary',
			method: 'POST',
			payload: {
				salesforce_object_id: salesforceObjectId,
				salesforce_object_type: salesforceObjectType,
			},
		});
	},
};

export default healthScoresService;
